<template>
    <div v-if="!noBankVisible" class="bank-info">
        <el-form
            ref="cardForm"
            :model="cardForm"
            :rules="rules"
            label-width="100px"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="证件类型:" :required="true" prop="certificatetype">
                <el-input v-model.trim="cardForm.certificatetype" disabled />
            </el-form-item>
            <el-form-item label="证件号码:" :required="true" prop="certificateno">
                <el-input v-model.trim="cardForm.certificateno" disabled />
            </el-form-item>
            <el-form-item label="真实姓名:" :required="true" prop="custname">
                <el-input v-model.trim="cardForm.custname" disabled />
            </el-form-item>
            <el-form-item label="选择账户:" :required="true" prop="account">
                <el-select
                    v-model="cardForm.account"
                    placeholder="请选择银行账户"
                    style="width: 440px"
                    v-on:change="selectAccount"
                >
                    <el-option
                        v-for="item in cardList"
                        :key="item.index"
                        :label="item.account"
                        :value="item.index"
                    />
                </el-select>
                <div v-show="cardList.length == 0" class="no_bank" v-on:click="noBankFn"></div>
            </el-form-item>
            <el-form-item label="银行卡号:" :required="true" prop="depositcard">
                <el-input
                    v-model.trim="cardForm.depositcard"
                    placeholder="选择银行账户后自动带出"
                    disabled
                />
            </el-form-item>
            <el-form-item label="手机号码:" :required="true" prop="mobileno">
                <el-input
                    v-model.trim="cardForm.mobileno"
                    placeholder="请输入手机号码"
                    :maxlength="11"
                />
            </el-form-item>
            <div class="btn-contain">
                <el-button class="cancel-btn" v-on:click="checkDialogClose">取消</el-button>
                <el-button class="confirm-btn" v-on:click="submitInfo">确定</el-button>
            </div>
            <div class="warn-tip">
                <div class="tip-title">温馨提示</div>
                <div class="tip-text">
                    1、为了保证您的账户安全，由于您不能通过原手机号码进行身份验证，系统将通过银行卡身份认证流程帮您完成手机号码修改。
                </div>
                <div class="tip-text">
                    2、如果您的支付渠道未在选择账户列表中，将无法自助修改手机号码，请致电客服
                    <span>{{ $cache.getCompanyInfoParam("10101009") }}</span>
                    。
                </div>
            </div>
        </el-form>
    </div>

    <div v-else class="auth-no-banks">
        <div class="code-contain">
            <img
                class="code-img"
                :src="
                    $util.imgSrc({
                        fileCode: $cache.getCompanyInfoParam('10106001')
                    })
                "
                alt=""
                srcset=""
            />
        </div>
        <div class="text-contain">
            <p class="text1">无法验证，请扫码下载APP</p>
            <p class="text2">您绑定的银行卡不支持验证，请下载基金APP，通过人脸识别</p>
            <p class="text3">修改手机号，或者联系人工客服。</p>
        </div>
        <div class="service-contain" v-on:click="toLinkServe">
            <div>
                <img src="@/assets/img/service.png" />
            </div>
            <div class="service-text">客服热线</div>
        </div>
        <div class="btn-contain">
            <div class="btn-text" v-on:click="checkDialogClose">知道了</div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";

export default {
    name: "CheckAcct",
    components: {},
    mixins: [mixin],
    data() {
        return {
            cardForm: {
                certificatetype: "",
                certificateno: "",
                custname: "",
                mobileno: "",
                account: "",
                depositcard: "",
                en_depositcard: ""
            },
            cardList: [], // 银行卡列表
            selectCard: {}, // 选中的银行卡
            rules: {
                account: [
                    {
                        required: true,
                        message: "请选择银行账户",
                        trigger: "blur"
                    }
                ],
                depositcard: [
                    {
                        required: true,
                        message: "请选择银行卡号",
                        trigger: "blur"
                    }
                ],
                mobileno: [
                    { required: true, message: "请输入手机号码", trigger: ["blur", "change"] },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ]
            },
            noBankVisible: false
        };
    },
    mounted() {
        const userInfo = this.$cache.getUser();
        this.cardForm.certificatetype = this.$cache.getDict("130007", userInfo.certificatetype);
        this.cardForm.certificateno = userInfo.certificateno;
        this.cardForm.custname = userInfo.custname;
        this.getBankInfo();
    },
    methods: {
        toLinkServe() {},
        noBankFn() {
            // this.$emit("change-title");
            // this.noBankVisible = true;
        },
        // 查询已绑定银行卡
        async getBankInfo() {
            const res = await userApi.getMyBankCards();
            if (res.data) {
                const array = res.data.data ? res.data.data : [];
                // 鉴权需要过滤掉汇款卡和柜台渠道
                this.cardList = array.filter((item) => {
                    return item.paycenterid != "0001" && item.paycenterid != "1000";
                });
                // 根据配置参数判断是否展示柜台的卡
                this.cardList = this.cardList.filter((item) => {
                    return this.$util.showCounterCard() || item.banktype != "1";
                });
                // 查渠道里面的配置
                const channelRes = await userApi.queryPaychannel();
                if (channelRes.data) {
                    const _arr = channelRes.data.paychannelInfoList
                        ? channelRes.data.paychannelInfoList
                        : [];
                    this.cardList.forEach((bankItem, bankIndex) => {
                        if (bankItem.specialflagofchannel.indexOf("t") > -1) {
                            this.$set(this.cardList[bankIndex], "identifytype", "1");
                        } else if (bankItem.specialflagofchannel.indexOf("u") > -1) {
                            this.$set(this.cardList[bankIndex], "identifytype", "2");
                        } else {
                            this.$set(this.cardList[bankIndex], "identifytype", "0");
                        }
                        _arr.forEach((channelItem) => {
                            if (bankItem.paycenterid == channelItem.paychannel) {
                                // s为短信鉴权，r为页面鉴权
                                if (channelItem.businessflag.indexOf("s") > -1) {
                                    this.$set(this.cardList[bankIndex], "bankauthtype", "1");
                                } else if (channelItem.businessflag.indexOf("r") > -1) {
                                    this.$set(this.cardList[bankIndex], "bankauthtype", "2");
                                } else {
                                    this.$set(this.cardList[bankIndex], "bankauthtype", "0");
                                }
                            }
                        });
                    });
                }
                this.cardList = this.cardList.filter((item) => {
                    return item.specialflagofchannel.indexOf("9") > -1;
                });

                this.cardList.forEach((card, index) => {
                    card.index = index;
                    card.account =
                        this.$cache.getDict("110080", card.bankcode) +
                        "-" +
                        this.$cache.getDict("110079", card.paycenterid) +
                        "（" +
                        card.depositcard.substr(-7, 7) +
                        "）";
                });
            }
        },
        // 选择银行账户
        selectAccount(value) {
            this.selectCard = this.cardList[value];
            this.cardForm.depositcard = this.selectCard.depositcard;
            this.cardForm.en_depositcard = this.selectCard.en_depositcard || "";
        },
        // 取消修改
        checkDialogClose() {
            this.cardForm = {};
            this.$emit("check-dialog-close");
        },
        // 确定修改手机号码
        submitInfo() {
            const _this = this;
            this.$refs["cardForm"].validate((valid) => {
                if (valid) {
                    _this.checkBankCard();
                }
            });
        },
        // 校验银行卡
        checkBankCard() {
            // 检测该网点所在渠道是否支持找回手机号码
            if (this.selectCard.specialflagofchannel.indexOf("9") < 0) {
                this.$message({
                    type: "warning",
                    message: "该网点所在渠道不支持找回手机号码！"
                });
                return;
            }
            let isDecryptObj = {};
            if (this.$cache.getIsEncrypted()) {
                isDecryptObj.en_custname = this.$cache.getUser().en_custname;
                isDecryptObj.en_depositname = this.$cache.getUser().en_custname;
                isDecryptObj.en_depositcard = this.selectCard.en_depositcard;
                isDecryptObj.en_certificateno = this.selectCard.en_certificateno;
            } else {
                isDecryptObj.custname = this.$cache.getUser().custname;
                isDecryptObj.depositname = this.$cache.getUser().custname;
                isDecryptObj.depositcard = this.selectCard.depositcard;
                isDecryptObj.certificateno = this.selectCard.certificateno;
            }
            const params = {
                ...isDecryptObj,
                bankcode: this.selectCard.bankcode,
                paychannel: this.selectCard.paycenterid,
                bankcardid: this.selectCard.bankcardid,
                mobileno: this.cardForm.mobileno,
                certificatetype: this.selectCard.certificatetype,
                channelid: this.selectCard.paycenterid + "" + this.selectCard.bankcode,
                channelname:
                    this.selectCard.paycentername +
                    "-" +
                    this.$cache.getDict("110080", this.selectCard.bankcode)
            };
            if (this.selectCard.bankauthtype == "0") {
                if (this.selectCard.identifytype == "1") {
                    // 短信签约
                    params.verifytype = "1";
                    params.signtype = "1";
                    params.authbiztype = "02";
                } else if (this.selectCard.identifytype == "2") {
                    // 页面签约
                    params.verifytype = "0";
                    params.signtype = "0";
                    params.authbiztype = "02";
                } else {
                    this.$message({
                        type: "warning",
                        message: "鉴权或签约方式未配置！"
                    });
                    return;
                }
            } else {
                if (this.selectCard.bankauthtype == "1") {
                    // 短信鉴权
                    params.verifytype = "1";
                    params.signtype = "1";
                    params.authbiztype = "01";
                } else if (this.selectCard.bankauthtype == "2") {
                    // 页面鉴权
                    params.verifytype = "0";
                    params.signtype = "0";
                    params.authbiztype = "01";
                } else {
                    this.$message({
                        type: "warning",
                        message: "鉴权或签约方式未配置！"
                    });
                    return;
                }
            }
            this.$emit("check-card-apply", params);
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/varibles";
.bank-info {
    padding: 30px 40px 10px;
    .el-form-item {
        margin-bottom: 23px !important;
    }
    .el-form-item__label {
        color: #333333;
    }
    .el-form-item__error {
        position: absolute;
        top: 100%;
        left: 0;
    }
    .el-form-item__error--inline {
        position: absolute;
        top: 100%;
        left: 0;
    }
    .btn-contain {
        text-align: center;
        .cancel-btn {
            padding: 10px 0;
            width: 180px;
            border-radius: 2px;
            background: #e4e4e4;
            font-size: 16px;
            font-weight: 500;
            color: #666666;
            border: 1px solid #e4e4e4;
            cursor: pointer;
        }
        .confirm-btn {
            margin-left: 40px;
            padding: 10px 0;
            width: 180px;
            border-radius: 2px;
            background: var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            border: 1px solid var(--color-primary);
            cursor: pointer;
        }
    }
    .warn-tip {
        padding: 30px 30px 0 0;
        .tip-title {
            font-size: 16px;
            font-weight: normal;
            color: #666666;
            line-height: normal;
            margin-bottom: 10px;
        }
        .tip-text {
            font-size: 14px;
            line-height: 26px;
            font-weight: normal;
            color: #333333;
            line-height: normal;
            margin-bottom: 5px;
        }
    }
    .no_bank {
        background-color: transparent;
        width: 440px;
        height: 40px;
        position: absolute;
        top: 0;
        z-index: 99;
        cursor: pointer;
    }
}
.auth-no-banks {
    .code-contain {
        padding-top: 20px;
        width: 100%;
        text-align: center;
        .code-img {
            width: 180px;
            height: 180px;
        }
    }
    .text-contain {
        .text1 {
            text-align: center;
            font-size: 18px;
            color: #3d3d3d;
            font-weight: 600;
            padding: 20px 0 5px;
        }
        .text2 {
            text-align: center;
            padding: 5px 0 5px;
        }
        .text3 {
            text-align: center;
            padding: 5px 0 30px;
        }
    }
    .service-contain {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $bg18;
        cursor: pointer;
        .service-text {
            padding-left: 5px;
        }
    }
    .btn-contain {
        text-align: center;
        font-size: 16px;
        display: flex;
        justify-content: center;
        margin-top: 25px;
        .btn-text {
            width: 190px;
            height: 44px;
            line-height: 44px;
            cursor: pointer;
            background-color: var(--color-primary);
            color: #ffffff;
        }
    }
}
</style>
